import { SGF_MAX_TEXT_BYTES } from "./sgf.js";

export async function readSgfFile(file: Pick<File, "size" | "arrayBuffer">): Promise<string> {
  if (file.size > SGF_MAX_TEXT_BYTES) throw new Error("棋谱文件超过 1 MiB");
  const bytes = await file.arrayBuffer();
  if (bytes.byteLength > SGF_MAX_TEXT_BYTES) throw new Error("棋谱文件超过 1 MiB");
  return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
}
